/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_ByokInputs */

const tr_faq_q_byok = /** @type {(inputs: Faq_Q_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi API anahtarımı kullanabilir miyim?`)
};

const en_faq_q_byok = /** @type {(inputs: Faq_Q_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use my own API key?`)
};

const de_faq_q_byok = /** @type {(inputs: Faq_Q_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich meinen eigenen API-Schlüssel verwenden?`)
};

const ru_faq_q_byok = /** @type {(inputs: Faq_Q_ByokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Могу ли я использовать собственный API-ключ?`)
};

/**
* | output |
* | --- |
* | "Can I use my own API key?" |
*
* @param {Faq_Q_ByokInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_byok = /** @type {((inputs?: Faq_Q_ByokInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_ByokInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_byok(inputs)
	if (locale === "de") return de_faq_q_byok(inputs)
	if (locale === "ru") return ru_faq_q_byok(inputs)
	return tr_faq_q_byok(inputs)
});